export default __webpack_public_path__ + "static/contacto_desktop-9416b46a3cbefd2668690380b9452982.jpg";